/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
import Joi from "joi";

export const signupSchema = Joi.object({
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .messages({
      "string.email": "Enter a valid email",
      "any.required": "Email is required",
      "string.empty": "Email is required",
    }),
  password: Joi.string().min(5).max(20).required().messages({
    "string.min": "Password should be at least 5 characters long",
    "string.max": "Password should be less than or equal to 20 characters",
    "any.required": "Password is required",
    "string.empty": "Password is required",
  }),
  firstName: Joi.string().min(4).max(20).required().messages({
    "string.min": "First name should be at least 4 characters long",
    "string.max": "First name should be less than or equal to 20 characters",
    "any.required": "First name is required",
    "string.empty": "First name is required",
  }),
  lastName: Joi.string().min(4).max(20).required().messages({
    "string.min": "Last name should be at least 4 characters long",
    "string.max": "Last name should be less than or equal to 20 characters",
    "any.required": "Last name is required",
    "string.empty": "Last name is required",
  }),
  company: Joi.string().min(4).max(20).required().messages({
    "string.min": "Company name should be at least 4 characters long",
    "string.max": "Company name should be less than or equal to 20 characters",
    "any.required": "Company name is required",
    "string.empty": "Company name is required",
  }),
  phone: Joi.object({
    code: Joi.any().required().messages({
      "any.required": "Phone code is required",
    }),
    phone: Joi.string()
      .trim()
      .max(14)
      .regex(/^[0-9]{4,14}$/)
      .required()
      .messages({
        "string.pattern.base": "Enter a valid phone number",
        "any.required": "Phone number is required",
        "string.empty": "Phone number is required",
        "string.max": "Phone should be less than or equal to 14 characters",
      }),
  })
    .required()
    .messages({
      "any.required": "Phone is required",
      "object.base": "Phone  is required",
      "object.empty": "Phone  is required",
    }),
  phoneCode: Joi.any(),
  domain: Joi.string()
    .regex(/^[A-Za-z0-9-]+$/)
    .min(4)
    .max(20)
    .required()
    .messages({
      "string.pattern.base": "Domain should have only number , aplhabet or `-`",
      "any.required": "Domain is required",
      "string.empty": "Domain is required",
      "string.min": "Domain name should be at least 4 characters long",
      "string.max": "Domain name should be less than or equal to 20 character",
    }),
});

export const emailValidation = Joi.string().email({ tlds: { allow: false } });
export const inputPhoneValidation = Joi.string()
  .trim()
  .max(14)
  .regex(/^[0-9]{4,14}$/)
  .messages({ "string.pattern.base": "Enter a valid phone number" });
export const inputStringValidation = Joi.string().min(4).max(20);
export const phoneCodeValdation = Joi.string();
export const inputNumberValidation = Joi.number();
export const domainValidation = Joi.string()
  .regex(/^[A-Za-z0-9-]+$/)
  .min(4)
  .max(20)
  .messages({
    "string.pattern.base": "Domain should have only number , aplhabet or `-`",
    "any.required": "Domain is required",
    "string.empty": "Domain is required",
  });

export const verifyDomainSchema = Joi.object({
  domain: Joi.string()
    .regex(/^[A-Za-z0-9-]+$/)
    .min(4)
    .max(20)
    .messages({
      "string.pattern.base": "Domain should have only number , aplhabet or `-`",
      "any.required": "Domain is required",
      "string.empty": "Domain is required",
    })
    .required(),
});

export const paswordSchema = Joi.object({
  password: Joi.string().trim().min(5).max(20).required().label("Password"),
});

export const updateEmailSchema = Joi.object({
  email: emailValidation.required().messages({
    "string.empty": `Email cannot be an empty field`,
    "any.required": `Email is a required field`,
    "string.email": `Email must be a valid email`,
  }),
});
